/*
(function($) {
    $(document).ready(function() {

        //HOME

        $('.full-slideshow').flickity({
            autoPlay: true,
            draggable: true,
            prevNextButtons: true,
            pageDots: true,
            wrapAround: true,
            resize: true,
            cellAlign: 'center',

            adaptiveHeight: true,
            setGallerySize: false,
        });

    });

})
(jQuery);
*/

(function($) {
    $(document).ready(function() {
        $('.full-slideshow').slick({
            infinite: true,
            dots: false,
            prevArrow: '',
            nextArrow: '',
            edgeFriction: 0,
            pauseOnFocus: false,
            pauseOnHover: false,
            speed: 1000,
            autoplay: true,
            autoplaySpeed: 5000
        });
    });
})
(jQuery);